import React, { useCallback } from "react";
import useProductName from "brand-customization/useProductName";
import PageHeader from "components/common/PageHeader";
import DocumentTitle from "components/common/DocumentTitle";
import UserNotification from "util/UserNotification";
import SectionGrid from "components/common/Section/SectionGrid";
import SectionComponent from "components/common/Section/SectionComponent";
import useHeaderBadge, { useUpdateHeaderBadge } from "customization/header-badge/useHeaderBadge";
import Spinner from "components/common/Spinner";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import WelcomePageConfiguration from "customization/welcome-page/WelcomePageConfiguration";
import useUpdateWelcomePageConfiguration from "customization/welcome-page/useWelcomePage";
import HeaderBadgeConfiguration from "./header-badge/HeaderBadgeConfiguration";
import ThemeEditor from "./theme-editor/ThemeEditor";
import PublicNotifications from "./public-notifications/PublicNotifications";
import EmailTemplateConfiguration from "./email-templates/EmailTemplateConfiguration";
const CustomizationPage = () => {
  const productName = useProductName();
  const { data: badgeConfig, isInitialLoading } = useHeaderBadge();
  const { mutateAsync: _updateHeaderConfiguration } = useUpdateHeaderBadge();
  const updateHeaderConfiguration = useCallback(
    (config) => _updateHeaderConfiguration(config).then(() => {
      UserNotification.success("Successfully updated.");
    }),
    [_updateHeaderConfiguration]
  );
  const { mutateAsync: _updateWelcomePageConfiguration } = useUpdateWelcomePageConfiguration();
  const updateWelcomePageConfiguration = useCallback(
    (config) => _updateWelcomePageConfiguration(config).then(() => {
      UserNotification.success("Successfully updated.");
    }),
    [_updateWelcomePageConfiguration]
  );
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      licenseSubject: LICENSE_SUBJECTS.customization,
      title: "Customization is disabled",
      text: "Customization is disabled because there is no valid Enterprise license.",
      bsStyle: "danger",
      displayWarningContainer: true,
      hideChildren: true
    },
    /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Customization" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Customization" }, /* @__PURE__ */ React.createElement("span", null, "Here you can customize your ", productName, " experience.")), /* @__PURE__ */ React.createElement(SectionGrid, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SectionComponent, { title: "Modify Global Theme" }, /* @__PURE__ */ React.createElement("p", null, "Any changes made & saved will affect all users."), /* @__PURE__ */ React.createElement(ThemeEditor, null)), /* @__PURE__ */ React.createElement(SectionComponent, { title: "Welcome Page RSS Feeds" }, /* @__PURE__ */ React.createElement(WelcomePageConfiguration, { updateConfig: updateWelcomePageConfiguration }))), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SectionComponent, { title: "Header Badge" }, /* @__PURE__ */ React.createElement(HeaderBadgeConfiguration, { config: badgeConfig, updateConfig: updateHeaderConfiguration })), /* @__PURE__ */ React.createElement(PublicNotifications, null), /* @__PURE__ */ React.createElement(SectionComponent, { title: "Email Notification Templates" }, /* @__PURE__ */ React.createElement(EmailTemplateConfiguration, null))))))
  );
};
export default CustomizationPage;
